import React from 'react';

import { Translation, Button } from '../../components/common';
import Link from '../../components/common/Link';
import Logo from '../../components/common/Logo/Logo.troy';

import { connectTo } from '../../utils';
import toErrorKey from './utils';

import { PAY_NOW_TEXT_KEY } from '../../constants/payment';
import * as routes from '../../constants/routes';
import * as errorTypes from '../../constants/errorStatuses';

import logo from '../../assets/img/logos/troy/troy_footer.png';
import smiley from '../../assets/img/error/smiley.png';

import styles from './index.module.scss';

class ErrorPage extends React.Component {
  render() {
    const { status } = this.props;
    const key = toErrorKey(status);

    return (
      <div className={styles['error__wrapper']}>
        <Translation className={styles['error__header']}>
          ERROR_PAGE_HEADER
        </Translation>
        <Translation className={styles['error__description']}>
          {key}
        </Translation>
        {[
          errorTypes.PAYMENT_CANCEL,
          errorTypes.PAYMENT_EXPIRED,
          errorTypes.PAYMENT_FAIL,
          errorTypes.PAYMENT_PENDING,
          errorTypes.PAYMENT_UNAUTHORIZED,
        ].some((value) => status === value) ? (
          <Link
            id="page.error.component.pay-now.pay-now-link"
            to={routes.PAYMENTS}
            className={styles['error__button-link']}
          >
            <Button
              id="page.error.component.pay-now.pay-now-button"
              onClick={this.onPayNowClick}
              className={styles['error__button']}
            >
              <Translation>{PAY_NOW_TEXT_KEY}</Translation>
            </Button>
          </Link>
        ) : (
          <Link id="page.error.component.error.home-link" to="/">
            <Logo src={logo} />
          </Link>
        )}
        <img src={smiley} className={styles['error__smile']} alt="smile" />
      </div>
    );
  }
}

export default connectTo(
  ({ error: { status } }) => ({ status }),
  {},
  ErrorPage
);
